import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#C9318E" }}>Brief</span>
            </h2>
            <p>
              Like many other industries, real state and associated businesses
              experience a pressing need for intervention from the latest
              technologies and digital solutions for increased efficiency and
              productivity.
            </p>
            <h2 style={{ color: "#717783" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#C9318E" }}> 2018</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#C9318E" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#C9318E" }}>MOBILE APPLICATION</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
